import React, {useEffect, useState} from 'react';
import Popover from '@src/components/Popover/Popover';
import Translate from '@src/components/Translate/Translate';
import {Placement} from '@popperjs/core';

export default function FlyErrorMessage(props: {
    error: Error | string | null,
    children: React.ReactNode,
    targetRef: React.RefObject<HTMLElement>,
    containerRef: React.RefObject<HTMLElement> | HTMLElement,
    popoverPlacement?: Placement,
    autoCloseDelay?: number,
}) {
    const {error, popoverPlacement, autoCloseDelay, children, containerRef, targetRef} = props;
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(error != null);

        if (!autoCloseDelay) {
            return;
        }

        const timeout = setTimeout(() => setIsOpen(false), autoCloseDelay);

        return () => void clearTimeout(timeout);
    }, [autoCloseDelay, error]);

    if (!error) {
        return <>{children}</>;
    }

    return <>
        <Popover
                isOpen={isOpen}
                itemRef={targetRef}
                placement={popoverPlacement}
                container={
                    containerRef != null ? (
                                    containerRef instanceof HTMLElement ?
                                            containerRef :
                                            containerRef.current
                            ) :
                            targetRef.current
                }
        >
            <Translate
                    tag="div"
                    message={typeof error === 'string' ? error : error.message}
                    className="text-danger"
            />
        </Popover>

        {children}
    </>;
}
